import {
  BROADCAST_TOGGLE_STAGE_SOURCE,
  BROADCAST_QUEUE_STAGE_LAYOUT,
  BROADCAST_CLEAR_STAGED_SOURCES
} from 'actions/Types';

export const initialState = {
  sceneLayout: null,
  sources: {}
};

export default (state = initialState, action) => {
  if (action.type === BROADCAST_TOGGLE_STAGE_SOURCE) {
    return {
      ...state,
      sources: action.payload
    };
  }

  if (action.type === BROADCAST_QUEUE_STAGE_LAYOUT) {
    return { ...state, sceneLayout: action.payload };
  }

  if (action.type === BROADCAST_CLEAR_STAGED_SOURCES) {
    return { ...state, sceneLayout: null, sources: {} };
  }

  return state;
};
